import { theme } from '@/theme';

export const styles = {
  publicLayoutWrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column' as const,
    background: theme.colors.bg,
  },

  outletContainer: {
    flex: 1,
  },

  loadingScreen: {
    minHeight: '100vh',
    background: theme.colors.bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.typography.fontFamily,
  },

  loadingCenterBox: {
    textAlign: 'center' as const,
  },

  loadingSpinner: {
    width: 48,
    height: 48,
    border: `3px solid ${theme.colors.border}`,
    borderTop: `3px solid ${theme.colors.primary}`,
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
    margin: '0 auto 16px',
  },

  loadingText: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.muted,
  },

  comingSoonContainer: {
    padding: '48px 0',
  },
} as const;
